import { AppFormAction as AppFormActionProps, AppFormBlock, AppFormFieldData, AppFormItem } from 'api'
import React, { Fragment, useState } from 'react'

export interface AppFormTabProps {
	isHidden?: boolean
	title?: string
	appFormBlockList?: AppFormBlock[]
	component?: string
	componentProps?: any
	tabId?: number
}

export interface FormFunction {
	befSaveForm?: (formData: any, appFormSaveData: any) => boolean
	saveForm?: (formData: any, appFormSaveData: any) => boolean
	afterSaveForm?: (formData: any, appFormSaveData: any) => boolean
}

export interface FormProps extends FormFunction {
	appFormTabList?: AppFormTabProps[]
	appFormActionList?: AppFormActionProps[]
	entity?: string
	metadataId?: string
	keyName?: string
	defaultTabId?: number
	customerData?: any
	mode?: number
	keyValue?: number
	className?: string
	apiPath?: string
	ref?: any
}

export interface AppFormContext {
	formData: any
	onChange?: (appFormItem: AppFormItem, value: any, label?: string) => void
	setCurrTabIndex?: (tabIndex: number) => void
	currTabIndex?: number
}
export const AppFormContext = React.createContext<AppFormContext>({} as AppFormContext)

export const initAppFormData = (data?: any, appFormTabList?: AppFormTabProps[]) => {
	let appFormDataList = [] as AppFormFieldData[]
	console.log('datadata', data, Object.keys(data))
	for (let field of Object.keys(data)) {
		let appFormItem = getFieldItem(field, appFormTabList)
		appFormDataList.push({
			changed: true,
			dataType: appFormItem.dataType,
			field,
			lable: appFormItem.label,
			save: appFormItem.isSave,
			unAllowSame: appFormItem.unAllowSame,
			unSameScopeField: appFormItem.unSameScopeField,
			value: data[field],
		})
	}
	return appFormDataList
}

export const getFieldItem = (field: string, appFormTabList?: AppFormTabProps[]) => {
	let appFormItemReturn = {} as AppFormItem
	appFormTabList.forEach((appFormTab: AppFormTabProps) => {
		appFormTab.appFormBlockList.forEach((appFormBlock: AppFormBlock) => {
			appFormBlock.appFormItemList &&
				appFormBlock.appFormItemList.forEach((appFormItem: AppFormItem) => {
					if (appFormItem.field === field) appFormItemReturn = appFormItem
				})
		})
	})
	return appFormItemReturn
}



// WEBPACK FOOTER //
// ./src/components/AppFormLayout/AppFormData.tsx